import React from "react";
import { Link } from "react-router-dom";

const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trading Conditions</h1>
        <p>
          Get the edge you need with precise, transparent, and real-time trading
          conditions. Explore key metrics like spreads, leverage, and margin
          requirements across all major Forex pairs to make informed trading
          decisions.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
